import { toFormData } from 'Helpers'
import { FIELDS_ARRAY, ProductModel } from 'Pages/orders'

const formDataParamsToArray = (fieldName: string, data: ProductModel, formData: FormData): void => {
	if (data?.[fieldName]) {
		formData.delete(`[data][${fieldName}]`)
		if (data[fieldName].length) {
			data[fieldName].forEach((value): void => {
				formData.append(`[data][${fieldName}][]`, value)
			})
		} else {
			formData.append(`[data][${fieldName}][]`, '')
		}
	}
}

export const prepareDataBeforeSend = (data: ProductModel): FormData => {
	const dataForApi = toFormData(data)
	if (data?.attachment_attributes) {
		dataForApi.delete('[data][attachment_attributes]')
		dataForApi.append('[data][attachment_attributes][file]', data.attachment_attributes)
	}
	FIELDS_ARRAY.forEach((fieldName): void => formDataParamsToArray(fieldName, data, dataForApi))
	return dataForApi
}
